module.exports = __webpack_public_path__ + "static/media/sukkot.63167d05.svg";